"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _FormCheckbox = _interopRequireDefault(require("./FormCheckbox"));

var _PropUtils = require("../../util/PropUtils");

var _Stack = _interopRequireDefault(require("../layout/Stack"));

var _CollapsibleLink = _interopRequireDefault(require("../general/CollapsibleLink"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class CheckboxGroup
 * @desc A single-selection component with big icons and titles.
 *
 * @param {string} [className]
 *     Class name(s) to add to the top-level container/div.
 * @param {string} [data-id="checkbox-group"]
 *     Defines the "data-id" for top-level HTML container.
 * @param {array} [values]
 *     List of identifiers for currently-selected options.
 * @param {array<CheckboxGroup~option>} [options]
 *     List of options with value, label, disabled and conditionalContent.
 * @param {function} [onValueChange]
 *     When the list of values changes.
 * @param {function} [onAdd]
 *     When you add to the list of values.
 * @param {function} [onRemove]
 *     When remove from the list of values.
 * @param {Object} [strings]
 *     An object containing the various blurbs of text rendered in the component.
 *
 */

/**
* @typedef CheckboxGroup~option
* @desc An option
*
* @property {node} [conditionalContent]
*     Content that appears below when the option is selected.
* @property {boolean} [disabled = false]
*     Disable the checkbox.
* @property {string} [label]
*     The label.
* @property {node} hint
*     Provides a help hint with provided text
* @property {node} helpTarget
*     Customize the target
* @property {string|number} [value]
*     The value identifier.
*/
var defaultRenderOption = function defaultRenderOption(_ref) {
  var checked = _ref.checked,
      className = _ref.className,
      dataId = _ref["data-id"],
      onValueChange = _ref.onValueChange,
      option = _ref.option;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    key: option.value
  }, /*#__PURE__*/_react.default.createElement(_FormCheckbox.default, {
    checked: checked,
    "data-id": dataId,
    disabled: option.disabled,
    helpTarget: option.helpTarget,
    hint: option.hint || option.labelHelpText,
    label: option.label,
    noSpacing: true,
    onValueChange: _underscore.default.partial(onValueChange, option),
    stacked: true,
    value: option.value
  }), (checked && option.conditionalContent || option.content) && /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-description"
  }, option.conditionalContent, option.content));
}; // this supports the add-on below


var CollapsibleContent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CollapsibleContent, _React$Component);

  var _super = _createSuper(CollapsibleContent);

  function CollapsibleContent() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, CollapsibleContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.props.initialState);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleToggle", function () {
      return _this.setState(function (_ref2) {
        var expanded = _ref2.expanded;
        return {
          expanded: !expanded
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CollapsibleContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          showText = _this$props.showText,
          _this$props$hideText = _this$props.hideText,
          hideText = _this$props$hideText === void 0 ? showText : _this$props$hideText,
          dataId = _this$props["data-id"];
      var expanded = this.state.expanded;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CollapsibleLink.default, {
        "data-id": dataId,
        title: expanded ? hideText || "Hide" : showText || "Show",
        expanded: expanded,
        noSpacing: true,
        onToggle: this._handleToggle
      }), expanded && children);
    }
  }]);
  return CollapsibleContent;
}(_react.default.Component); // this is an add-on for the basic checkbox group

/** @function renderNestedCheckboxes
 * @desc function that can be passed to CheckboxGroup's renderOption prop to enable nested checkboxes
 * @memberof CheckboxGroup
 *
 * @param {object} props
 *
 * @param {boolean} props.checked
 * @desc Whether this option is checked
 * @param {string} className
 * @param {string} data-id
 * @param {function} onValueChange
 * @param {CheckboxGroup~option} option
 * @param {array} option.children
 * @desc Additional property to nest options within options
 * @param {string[]} values
*/


var renderNestedCheckboxes = function renderNestedCheckboxes() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$showText = _ref3.showText,
      showText = _ref3$showText === void 0 ? function (option) {
    return "Show ".concat(option.children.length);
  } : _ref3$showText,
      _ref3$hideText = _ref3.hideText,
      hideText = _ref3$hideText === void 0 ? "Hide" : _ref3$hideText;

  return function (_ref4) {
    var _context2, _context3;

    var mainChecked = _ref4.checked,
        className = _ref4.className,
        dataId = _ref4["data-id"],
        _onValueChange = _ref4.onValueChange,
        mainOption = _ref4.option,
        values = (0, _values.default)(_ref4);

    var renderCheckBox = function renderCheckBox(option, checked, checkboxDataId) {
      var disable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var indeterminate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      return /*#__PURE__*/_react.default.createElement(_FormCheckbox.default, {
        className: (0, _classnames.default)({
          "input-checkbox--indeterminate": indeterminate
        }),
        key: option.value,
        checked: checked,
        "data-id": checkboxDataId,
        disabled: option.disabled || disable,
        helpTarget: option.helpTarget,
        hint: option.hint || option.labelHelpText,
        label: option.label,
        noSpacing: true,
        onValueChange: function onValueChange() {
          return _onValueChange(option);
        },
        stacked: true,
        value: option.value
      });
    }; // if the parent is not checked, but some children are, show as indeterminate


    var indeterminate = mainOption.children && !mainChecked && (0, _some.default)(_context2 = mainOption.children).call(_context2, function (child) {
      return (0, _includes.default)(values).call(values, child.value);
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      key: mainOption.value
    }, renderCheckBox(mainOption, mainChecked, dataId, false, indeterminate), mainOption.children && /*#__PURE__*/_react.default.createElement("div", {
      className: "checkbox-description"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      wrappers: true
    }, /*#__PURE__*/_react.default.createElement(CollapsibleContent, {
      "data-id": "".concat(dataId, "-collapsible"),
      showText: typeof showText === "function" ? showText(mainOption) : showText,
      hideText: typeof hideText === "function" ? hideText(mainOption) : hideText,
      initialState: {
        expanded: mainOption.expanded
      },
      key: mainOption.expanded ? "collapsible-expanded" : "collapsible-collapsed"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      gap: "SM"
    }, (0, _map.default)(_context3 = mainOption.children).call(_context3, function (option) {
      var _context4;

      return renderCheckBox(option, (0, _includes.default)(values).call(values, mainOption.value) || (0, _includes.default)(values).call(values, option.value), (0, _concat.default)(_context4 = "".concat(dataId, "-")).call(_context4, option.value), (0, _includes.default)(values).call(values, mainOption.value));
    }))))));
  };
};

var CheckboxGroup = function CheckboxGroup(_ref5) {
  var className = _ref5.className,
      dataId = _ref5["data-id"],
      setCheckboxDataId = _ref5.setCheckboxDataId,
      values = (0, _values.default)(_ref5),
      options = _ref5.options,
      onValueChange = _ref5.onValueChange,
      onAdd = _ref5.onAdd,
      onRemove = _ref5.onRemove,
      renderOption = _ref5.renderOption;

  var isChecked = function isChecked(option) {
    return (0, _find.default)(_underscore.default).call(_underscore.default, values, function (value) {
      return value === option.value;
    }) ? true : false;
  };

  var removeFromValues = function removeFromValues(value) {
    return (0, _filter.default)(_underscore.default).call(_underscore.default, values, function (eachValue) {
      return eachValue !== value;
    });
  };

  var addToValues = function addToValues(value) {
    var _context5;

    return (0, _concat.default)(_context5 = []).call(_context5, removeFromValues(value), [value]);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "stack-sm",
    "data-id": dataId
  }, (0, _map.default)(_underscore.default).call(_underscore.default, options, function (option, index) {
    if ((0, _typeof2.default)(option) !== "object") {
      option = {
        value: option,
        label: option,
        conditionalContent: ""
      };
    }

    var handleValueChange = function handleValueChange(thisOption, value, e) {
      if (isChecked(thisOption)) {
        onValueChange(removeFromValues(thisOption.value), e);
        onRemove(thisOption.value);
      } else {
        onValueChange(addToValues(thisOption.value), e);
        onAdd(thisOption.value);
      }
    };

    var checked = isChecked(option, values);
    return renderOption({
      checked: checked,
      className: className,
      "data-id": setCheckboxDataId ? setCheckboxDataId(option, index) : dataId + "-" + option.value,
      onValueChange: handleValueChange,
      option: option,
      values: values
    });
  }));
};

CheckboxGroup.propTypes = {
  values: _propTypes.default.arrayOf(_PropUtils.valueProp),
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
    disabled: _propTypes.default.bool,
    value: _PropUtils.valueProp.required,
    label: _propTypes.default.node,
    labelHelpText: _propTypes.default.string,
    // just an alias for hint
    hint: _propTypes.default.string,
    helpTarget: _propTypes.default.node,
    conditionalContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
  }), _propTypes.default.string])),
  onValueChange: _propTypes.default.func,
  onAdd: _propTypes.default.func,
  onRemove: _propTypes.default.func
};
CheckboxGroup.defaultProps = {
  "data-id": "checkbox-group",
  values: [],
  options: [],
  onValueChange: _underscore.default.noop,
  onAdd: _underscore.default.noop,
  onRemove: _underscore.default.noop,
  renderOption: defaultRenderOption
};
CheckboxGroup.renderNestedCheckboxes = renderNestedCheckboxes;
var _default = CheckboxGroup;
exports.default = _default;
module.exports = exports["default"];